<template>
	<div class="bg-white" id="gallery">
		<span class="position-relative" style="top:-50px" id="room-type"></span>
		<div class="hide-768px">
			<HomeNavbarDesktop @shareClick="shareClick" @callClick="callClick" :class="{'d-none':scrollPosition >20}" />
		</div>
		<div class="show-768px">
			<HomeNavbarMobile @shareClick="shareClick" @callClick="callClick" />
		</div>
		<div v-if="is_load" class="w-100 py-4 mt-5 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="px-10 w-100 position-sticky w-100 bg-white z-index-1036 border-bottom" :class="{'top-0':scrollPosition >20,'top-80px':widthScreen}">
	  		<div class="row">
	  			<div class="col-12 col-lg-2 py-3">
            <router-link :to="'/'+getMerchant.code">
		  				<img src="../../assets/img/icon/back.png" class="d-inline-block cursor-pointer" @click="showGallery(false)" width="20">
		    			<p class="mb-0 body-1-2 d-inline-block position-relative ml-1 cursor-pointer" style="top:1px" @click="showGallery(false)" width="20">{{$t('general.back')}}</p>
		    		</router-link>
	  			</div>
	  			<div class="div-wrapper w-100 desktop-none">
		  			<div style="width: max-content;">
		  				<div class="d-inline-block mr-3 pr-2 cursor-pointer" :class="{'pl-4':index==0,'pr-4':index == full_gallery.length-1}" v-for="(category,index) in full_gallery" @click="toggleGoScroll(category.name)" v-if="category.image_list.length != 0">
		  					<p class="mb-0 body-2-2 text-15 py-3 text-semi-dark font-semibold" :class="{'text-color-green font-bold border-bottom-green-3':category.active}" style="color:#8c8c8c">{{category.name}}</p>
		  				</div>
		  			</div>
		  		</div>
	  			<div class="col-12 col-lg-10 border-left mobile-none">
	  				<div class="d-inline-block mr-3 pr-2 cursor-pointer" v-for="category in full_gallery" @click="toggleGoScroll(category.name)" v-if="category.image_list.length != 0">
	  					<p class="mb-0 body-2-2 text-15 py-3 text-semi-dark font-semibold" :class="{'text-color-green font-bold border-bottom-green-3':category.active}" style="color:#8c8c8c">{{category.name}}</p>
	  				</div>
	  			</div>
	  		</div>
	  	</div>
	    <div class="px-10 bg-white position-relative" :class="{'top-115px':widthScreen}" style="top:75px">
				<!-- GALLERY -->
		 		<template v-for="gallery in full_gallery">
		 			<div class="position-relative" :id="gallery.name" style="top:-80px"></div>
		    	<div class="row slim-grid-row mb-5" v-if="gallery.image_list.length != 0">
		    		<div class="col-12 col-lg-12 position-sticky target-sticky">
		    			<div class="position-stickyz top-84px d-block">
		    				<p class="mb-0 pb-4 text-20 font-semibold">{{gallery.name}}</p>
		    			</div>
		    		</div>
	        	<div class="col-12 col-md-6 col-lg-4 mb-3" 
	        		v-for="(image_slider,index_image_slider) in gallery.image_list" 
	        		:key="index_image_slider" 
	        		@click="togglePopUpGallery(index_image_slider,image_slider,gallery.id)">
	        			<img :src="image_slider.image_url" class="object-fit w-100 cursor-pointer" alt="" height="300">
	        	</div>
		    	</div>
		    	<CoolLightBox 
			      :items="gallery.image_list"
			      srcName="image_url" 
			      :index="index"
			      :fullScreen="true"
			      :closeOnClickOutsideMobile="true"
			      @close="index = null;"
			      v-if="gallery.id == gallery_id"
			      >
			    </CoolLightBox>
		  	</template>
		  	<div class="menu-to-top cursor-pointer align-self-center" @click="goToTop()">
			  	<img src="../../assets/img/icon/back.png" class="d-inline-block transform-90 position-relative" style="left: 1px;bottom: 3px;" width="20">
		  	</div>
		  </div>
    </template>
    <div style="height: 200px;"></div>
	  <!-- FOOTER -->
		<Footer></Footer>
	</div>
</template>

<script>
	import {mapGetters,mapMutations} from 'vuex';
	import moment from 'moment';
	import {get} from '@/services/index.js'
  import {formatCurrency,formatDate} from '@/utils/index.js'
	import CoolLightBox from 'vue-cool-lightbox'
  import Footer from '@/components/hotel/Footer.vue';
	import HomeNavbarDesktop from '@/components/hotel/be/desktop/HomeNavbar'
	import HomeNavbarMobile from '@/components/hotel/be/mobile/HomeNavbar'

	export default{
		components:{
			CoolLightBox,
			Footer,
			HomeNavbarDesktop,
			HomeNavbarMobile				
		},
		data(){
			return{
        scrollPosition: null,
        index: null,
        id_gallery: null,
        is_load: true,
        room_type:"",
				date:{
					check_in: moment().toDate(),
					check_out: moment(moment().add(1,'d')).toDate()
				},
				full_gallery:'',
				gallery_id: null,
				widthScreen: window.innerWidth <= 768
			}
		},
		mounted(){
      window.addEventListener('scroll', this.updateScroll);
			this.goToTop()
      this.loadGallery()
      // this.loadSticky()
			
		},
		computed:{
			...mapGetters(['getMerchant','getCurrentUser','isNotLogin','getRoomStay'])
		},
		methods:{
      ...mapMutations(['setBeFilter']),
			goToTop(){
				document.getElementById('gallery').scrollIntoView({
	        behavior: 'smooth'
	      });
			},
			toggleGoScroll(data){
				document.getElementById(data).scrollIntoView({
	        behavior: 'smooth'
	      });
			},
			updateScroll() {
        this.scrollPosition = window.scrollY
      },
			loadGallery(){
				this.is_load = true
				return new Promise((success,fail)=>{
					get("CORE_HOTEL",`v2/merchant-gallery/${this.getMerchant.id}`).then(response=>{
						if (response.data.success) {
							this.full_gallery = response.data.data
							success()
						}else{
							fail(response.data.message)
						}
						this.is_load = false
					})
				})
			},
			formatTime(date){
				let format = "YYYY-MM-DD"
        return moment(date).format(format)
      },
      formatCurrency(data) {
        return formatCurrency(data)
      },
			callClick(){
				this.$emit('callClick')
			},
			detailRoomType(){
				this.$router.push(`/${this.getMerchant.code}/room-type/detail`)
			},
			headerMobile(){
				this.responsive.mobile_header = !this.responsive.mobile_header
			},
			callClick(){
      	this.$trackHomeClick('NAVBAR','Clicked menu call')
      	setTimeout(()=>{
      		let tag_a = document.createElement('a')
      		tag_a.href = `tel:${this.getMerchant.phone}`
      		tag_a.click()
      		tag_a.remove()
      	},300)
      },
      shareClick(){
      	 this.$trackHomeClick('NAVBAR','Clicked menu share')
        var value = window.location.href;
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.$notify({
				  title: 'Share',
				  type: 'success',
				  position: 'top left',
				  text: 'Successfully copy the url'
				});
      },
      loadSticky(){
      	const el = document.querySelector(".target-sticky")
				const observer = new IntersectionObserver( 
				  ([e]) => e.target.classList.toggle("sticky-active", e.intersectionRatio < 1),
				  { threshold: [1] }
				);

				observer.observe(el);
      },
      toggleIdGallery(data){
      	this.id_gallery = data
      },
      togglePopUpGallery(data,id,gallery_id){
      	this.index = data
      	this.gallery_id = gallery_id
      	this.toggleIdGallery(id.id)
      },
    }
	}
</script>
<style scoped >
	.target-sticky.sticky-active{
		background-color:red;
	}
	.top-115px{
		top: 115px!important;
	}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/Gallery.vue